
import React from "react";
import PricingWithBooking from "@/components/PricingWithBooking";

const Pricing = () => {
  return <PricingWithBooking />;
};

export default Pricing;
